import { Component, OnInit } from '@angular/core';
// import { Router } from '@angular/router';
import { ArticleListConfig, UserService, HomeService } from '../shared';
import { SearchService, ContextService } from '../shared';
import { NguCarousel, NguCarouselStore } from '@ngu/carousel';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router, NavigationEnd  } from '@angular/router';

@Component({
  selector: 'home-page',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [SearchService, ContextService]
})

export class HomeComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private homeService: HomeService,
    private searchService: SearchService,
    private contextService: ContextService,

  ) {
     window.scrollTo(0, 0);



  }

  query: string;
  editeur: number;
  niveau: number;
  classe: number;
  type: number;
  discipline: number;
  imgags: string[];
  carouselOne: NguCarousel;
  editeurs:Array<any> = [];
  editeurscarousel:Array<any> = [];
  niveaux:Array<string> = [];
  disciplines:Array<string> = [];
  classes:Array<string> = [];
  types:Array<any> = [];
  nouveautes:Array<any> = [];
  actualites:Array<any> = [];
  context: string;
  context_route: string;
  imgfolder_url;
  stringinvalid:boolean=false;
  window: any;

  ngOnInit() {
     this.context = this.contextService.getContext();
    this.context_route = (this.context == 'B2B')?'':'/familles';
     this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          this.context= (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.context_route=(this.context=='B2B')?'':'/familles'; 
        }
          
     });


     this.window = window;



    this.imgfolder_url=environment.imgfolder_url;
    this.carouselOne = {
        grid: {xs: 2, sm: 2, md: 3, lg: 6, all: 0},
        slide: 3,
        speed: 400,
        interval: 4000,
        point: {
          visible: false
        },
        load: 2,
        //touch: true,
        loop: true,
        custom: 'banner'
    }

    this.homeService.getAllEditeurs()
      .subscribe(editeurs => {
        // console.log(editeurs)
        this.editeurs = editeurs;

        let tmpEditeurs=[]

        editeurs.forEach( function(item){
          tmpEditeurs.push(item);
        });

        this.editeurscarousel=tmpEditeurs;
       let firstpart=this.editeurscarousel.splice(0,9)
        this.editeurscarousel = this.editeurscarousel.concat(firstpart)

    });

    this.homeService.getAllNiveaux()
      .subscribe(niveaux => {
        this.niveaux = niveaux;
    });

    this.homeService.getAllDisciplines()
      .subscribe(disciplines => {
        this.disciplines = disciplines;
    });

    this.homeService.getAllClasses()
      .subscribe(classes => {

        this.classes = classes;
    });

    this.homeService.getAllTypes()
      .subscribe(types => {
        this.types = types;
        this.types = this.types.filter( t => t.publication == true );
    });
 
  /*  this.homeService.getAllNouveautes()
      .subscribe(nouveautes => {
        console.log(nouveautes);
        this.nouveautes = nouveautes;
    });
*/
    this.homeService.getCmsDatas()
      .subscribe(data => {
     
        this.actualites = data['actu'].filter( actu => actu.users.includes(this.context) );
        if(this.actualites.length > 4) this.actualites = this.actualites.slice(0, 4);
        this.nouveautes = data['nouv'].filter( nouv => nouv.users.includes(this.context) );
        if(this.nouveautes.length > 6) this.nouveautes = this.nouveautes.slice(0, 6);
        // console.log(this.nouveautes)
    });

    
  }

   onmoveFn() {
    // console.log(data);
  }


  onChangeNiveau(idNiveau) {
     this.homeService.getClassesByNiveau(idNiveau).subscribe(classes => {
        //console.log(classes)
        this.classes = classes;
    });

     this.homeService.getDisciplinesByNiveau(idNiveau).subscribe(disciplines => {
      
        this.disciplines = disciplines;
    });

  }

  onSubmit(data){
    // console.log(data);
    this.stringinvalid=false
    

    this.context = this.contextService.getContext();
    if(this.query != '' && this.query != undefined){
      if(this.query.length<2){
       this.stringinvalid=true;
       return;
    }

      
      sessionStorage.setItem('search_request_hachette_kne', JSON.stringify({
        marche: this.context,
        plaintext: this.query,
        editeur: [+this.editeur],
        niveau: [+this.niveau],
        classe: [+this.classe],
        typeArticle: [+this.type],
        discipline: [+this.discipline]
      }));
    } else {
      sessionStorage.setItem('search_request_hachette_kne', JSON.stringify({
        marche: this.context,
        editeur: [+this.editeur],
        niveau: [+this.niveau],
        classe: [+this.classe],
        typeArticle: [+this.type],
        discipline: [+this.discipline]
      }));
    }






    
    if(this.query != '' && this.query != undefined){
      if(this.context != 'B2B'){
        this.router.navigate(['/familles/recherche/' + this.query ])
      } else {
        this.router.navigate(['/recherche/' + this.query ]);
      }

      
    } else {
      if(this.context != 'B2B'){
        this.router.navigate(['/familles/recherche/'])
      } else {
        this.router.navigate(['/recherche']);
      }
      
    }

  }

  scrollTop(){
    window.scrollTo(0, 0);
  }


}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts